import React from 'react';
const PolicyDetailsHeader = ({ polNo }) => (
    <div className="pageHeader">
        <h3>
            Contract Details: {polNo}
        </h3>
    </div>
);
export default PolicyDetailsHeader;